import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles/CheckoutSidebarPricingRow.scss';

const CheckoutSidebarPricingRow = props => {
    const { label, value, rowType, formatStyle, hasTopBorder, isMainPrice, discountFrom } = props;
    const dataTn = (rowType || '').toLowerCase().replace(/_/gi, '-');

    if (!label && !value) {
        return null;
    }

    const valueClasses = classNames({
        [styles.discountPrice]: formatStyle === 'DISCOUNT',
        [styles.mainPrice]: isMainPrice,
    });

    return (
        <div
            className={classNames({
                [styles.priceRow]: true,
                [styles.borderTop]: hasTopBorder,
            })}
            data-tn={`${dataTn}-row`}
        >
            <span data-tn={`${dataTn}-label`}>{label}</span>
            <span className={valueClasses} data-tn={`${dataTn}-value`}>
                {discountFrom && <span className={styles.inactivePrice}>{discountFrom}</span>}{' '}
                <span data-tn={dataTn === 'price' ? 'offer-price' : null}>{value}</span>
            </span>
        </div>
    );
};

CheckoutSidebarPricingRow.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.element]).isRequired,
    rowType: PropTypes.string,
    formatStyle: PropTypes.string,
    hasTopBorder: PropTypes.bool,
    theme: PropTypes.objectOf(PropTypes.string),
    isMainPrice: PropTypes.bool,
    discountFrom: PropTypes.string,
};

export default CheckoutSidebarPricingRow;
